import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../components/Modal';
import { useAppContext } from '../../../contexts/auth';

interface ILockModal {
  setLockModalShow: Dispatch<SetStateAction<boolean>>;
  lockCompany: () => Promise<void>;
  lockModalShow: boolean;
  isUnlocked: boolean;
  unlockAccess: () => Promise<void>;
}

export default function LockModal({
  setLockModalShow,
  lockCompany,
  lockModalShow,
  isUnlocked,
  unlockAccess,
}: ILockModal) {
  const { selectedCompany } = useAppContext();

  return (
    <MyModal
      title={`${isUnlocked ? 'Bloquear' : 'Liberar'} o acesso da empresa ${selectedCompany.label}`}
      closeButtonLabel="Cancelar"
      actionButtonLabel={isUnlocked ? 'Bloquear' : 'Liberar'}
      modalBody={(
        <div>
          Tem certeza que deseja {isUnlocked ? 'bloquear' : 'liberar'} o acesso da empresa
          {' '}
          <strong>{selectedCompany.label}</strong>
          {' '}
          ?
        </div>
      )}
      onClose={() => setLockModalShow(false)}
      onAction={() => isUnlocked ? lockCompany() : unlockAccess()}
      show={lockModalShow}
      type={isUnlocked ? 'suspendAction' : 'activateAction'}
    />
  );
}
